"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportVirtualCategories = void 0;
const routes_1 = require("../../routes");
const exportVirtualCategories = (client) => async (params) => {
    const url = routes_1.ENDPOINTS.EXPORT_VIRTUAL_CATEGORIES.applyParams(params);
    const response = await client.get(url, {
        headers: {
            Accept: 'application/json',
        },
    });
    const count = parseInt(response.headers['x-total-count'] ?? '0', 10);
    return {
        categories: response.data,
        count,
    };
};
exports.exportVirtualCategories = exportVirtualCategories;
